import { api } from './api';
import { CobrancaFinanceiro, ApiResponse } from '../types';

export const CobrancaFinanceiroService = {
  async getAll(params?: any): Promise<CobrancaFinanceiro[]> {
    const response = await api.get<CobrancaFinanceiro[]>('/cobrancas-financeiro', { params });
    // O interceptor do axios retorna response.data, que é o array de cobranças no nosso caso (baseado no controller)
    // Mas o tipo ApiResponse esperado pelo interceptor é { success: boolean, data: T ... }
    // No entanto, o controller retorna diretamente o array ou um objeto. 
    // Vamos tratar ambos os casos baseado no padrão do resto do projeto.
    return (response as any); 
  },

  async getById(id: number): Promise<CobrancaFinanceiro> {
    const response = await api.get<CobrancaFinanceiro>(`/cobrancas-financeiro/${id}`);
    return (response as any);
  },

  async create(data: Partial<CobrancaFinanceiro>): Promise<CobrancaFinanceiro> {
    const response = await api.post<CobrancaFinanceiro>('/cobrancas-financeiro', data);
    return (response as any);
  },

  async update(id: number, data: Partial<CobrancaFinanceiro>): Promise<CobrancaFinanceiro> {
    const response = await api.put<CobrancaFinanceiro>(`/cobrancas-financeiro/${id}`, data);
    return (response as any);
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/cobrancas-financeiro/${id}`);
  }
};
